export const CLOSED_CATEGORY_MAX_ITEMS_COUNT = 3;
